export default __webpack_public_path__ + "static/media/guardian_icon.cb67c305.png";